import { render } from "./EditPassword.vue?vue&type=template&id=0663f2a2"
import script from "./EditPassword.vue?vue&type=script&lang=js"
export * from "./EditPassword.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "0663f2a2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0663f2a2', script)) {
    api.reload('0663f2a2', script)
  }
  
  module.hot.accept("./EditPassword.vue?vue&type=template&id=0663f2a2", () => {
    api.rerender('0663f2a2', render)
  })

}

script.__file = "src/views/settings/modules/EditPassword.vue"

export default script